import { useBreakpoint } from '@dropbox/dig-components/hooks';
import { Title, Text } from '@dropbox/dig-components/typography';
import { Box, Split } from '@dropbox/dig-foundations';
import { PictogramIcon } from '@dropbox/dig-icons';
import { SignatureLine } from '@dropbox/dig-icons/dist/mjs/assets';
import React from 'react';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';

interface Props {
  title: string | React.ReactNode;
  message: string | React.ReactNode;
  children?: React.ReactNode;
  actions: React.ReactNode[];
}

const Banner = ({ title, message, children, actions }: Props) => {
  const { small: isAboveSmallViewPort } = useBreakpoint();

  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        backgroundColor="Background Subtle"
        paddingTop="Micro XLarge"
        paddingX="Micro Large"
        paddingBottom="Macro Small"
      >
        <Split gap="Macro Small">
          {isAboveSmallViewPort && (
            <Split.Item>
              <PictogramIcon src={SignatureLine} />
            </Split.Item>
          )}

          <Split.Item width="fill">
            <Box
              display="flex"
              alignItems="flex-start"
              justifyContent="space-between"
              flexDirection="column"
              paddingY="Micro Small"
              rowGap="Micro Small"
            >
              <Title size="medium" weightVariant="emphasized">
                {title}
              </Title>
              <Text color="standard">{message}</Text>
              {children}
              <Split
                gap="Micro Small"
                paddingTop="Micro Medium"
                alignX="left"
                width="100%"
              >
                {actions.map((action, index) => (
                  <Split.Item key={index}>{action}</Split.Item>
                ))}
              </Split>
            </Box>
          </Split.Item>
          {isAboveSmallViewPort && (
            <Split.Item>
              <Box paddingX="Macro Medium"></Box>
            </Split.Item>
          )}
        </Split>
      </Box>
    </WhiteLabelThemeProvider>
  );
};

export default Banner;
